import { useQuery } from '@tanstack/react-query';
import { getName } from '../core/getName.js';

/**
 * It leverages the `@tanstack/react-query` hook for fetching and optionally caching the ENS name
 * @param {UseNameOptions} arguments
 * @param {Address} arguments.address - The Ethereum address for which the ENS name is to be fetched.
 * @param {UseNameQueryOptions} queryOptions - Additional query options, including `enabled` and `cacheTime`
 * @param {boolean} queryOptions.enabled - Whether the query should be enabled. Defaults to true.
 * @param {number} queryOptions.cacheTime - Cache time in milliseconds.
 * @returns An object containing:
 *  - `ensName`: The fetched ENS name for the provided address, or null if not found or in case of an error.
 *  - `{UseQueryResult}`: The rest of useQuery return values. including isLoading, isError, error, isFetching, refetch, etc.
 */
const useName = ({
  address
}, queryOptions) => {
  const _ref = queryOptions ?? {},
    _ref$enabled = _ref.enabled,
    enabled = _ref$enabled === void 0 ? true : _ref$enabled,
    cacheTime = _ref.cacheTime;
  const ensActionKey = `ens-name-${address}`;
  return useQuery({
    queryKey: ['useName', ensActionKey],
    queryFn: async () => {
      return await getName(address);
    },
    gcTime: cacheTime,
    enabled,
    refetchOnWindowFocus: false
  });
};
export { useName };
//# sourceMappingURL=useName.js.map
